import { twMerge, type ClassNameValue } from "tailwind-merge";

/**
 * Utility function to combine Tailwind classes conditionally.
 * Inspired by its usage in shadcn/ui: https://akhilaariyachandra.com/snippets/using-clsx-or-classnames-with-tailwind-merge
 *
 * Does not use `clsx` because we only require `string` arguments and not object or falsy arguments.
 *
 * Optionally, you can add special regex to your Tailwind VSCode plugin to ensure you have linting and autocomplete: https://github.com/paolotiu/tailwind-intellisense-regex-list?tab=readme-ov-file
 */
export function cn(...inputs: ClassNameValue[]) {
  return twMerge(inputs);
}
